// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_nfT","cls2":"CitationModal-cls2_pKh CitationModal-cls1_nfT"};